import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/sections/Hero';
import { StatsBand } from './components/sections/StatsBand';
import { Transformation } from './components/sections/Transformation';
import { PainPoints } from './components/sections/PainPoints';
import { Insight } from './components/sections/Insight';
import { Volumes } from './components/sections/Volumes';
import { LearningTools } from './components/sections/LearningTools';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Urgency } from './components/sections/Urgency';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream" data-id="element-0" data-mp="3mjq45l4rr2xp">
      <MetaPixel data-id="element-1" data-mp="3rbzo8kj7d8s2" />
      <Hero data-id="element-2" data-mp="3rdkg22e4udm8" />
      <main data-id="element-3" data-mp="3rd1bdndhtlq5">
        <StatsBand data-id="element-4" data-mp="3recdlirailf5" />
        <Transformation data-id="element-5" data-mp="5yhgo69t1c8" />
        <PainPoints data-id="element-6" data-mp="680tswt8a8y" />
        <Insight data-id="element-7" data-mp="4n725ibkvc5" />
        <Volumes data-id="element-8" data-mp="56lhc8rh1lf" />
        <LearningTools data-id="element-9" data-mp="7stte3h7l4p" />
        <Bonuses data-id="element-10" data-mp="2zllen0i82im7" />
        <Offer data-id="element-11" data-mp="2zm4zaoz9bl3x" />
        <Urgency data-id="element-12" data-mp="2zmo557bmuj1l" />
        <Guarantee data-id="element-13" data-mp="2zn6actg9w7ln" />
        <Testimonials data-id="element-14" data-mp="33mouvo46mgny" />
        <Author data-id="element-15" data-mp="33m5eibu6k0c1" />
        <FAQ data-id="element-16" data-mp="33nq55qddiz4m" />
        <FinalCTA data-id="element-17" data-mp="33n6yj5t6bx5w" />
      </main>
      <Footer data-id="element-18" data-mp="33oi0r16z0wuw" />
      <FloatingCTA data-id="element-19" data-mp="38m1gk5jbhhoy" />
      <PurchasePopup data-id="element-20" data-mp="38li7lebna3n2" />
    </div>;
}